export const ERROR_UNAUTHORIZED = 1;
export const ERROR_FEATURE_NOT_SUPPORTED = 7;
export const ERROR_ACCESS_DENIED = 8;
export const ERROR_PERMISSION_DENIED = 11;
